import { render, staticRenderFns } from "./info-dialog.vue?vue&type=template&id=c2aef020&scoped=true"
import script from "./info-dialog.vue?vue&type=script&lang=js"
export * from "./info-dialog.vue?vue&type=script&lang=js"
import style0 from "./info-dialog.vue?vue&type=style&index=0&id=c2aef020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aef020",
  null
  
)

export default component.exports